import React from "react";

const ManageStudentDialog = ({
  student,
  coaches,
  onClose,
  onRemoveAssignment,
  onRemoveAllAssignments,
}) => {
  if (!student) return null;

  const getCoachName = (coachValue) => {
    if (!coachValue) return null;

    // Try to find coach by ID
    const coach = coaches?.find(c => String(c._id) === String(coachValue));
    if (coach) {
      return `${coach.firstName} ${coach.lastName}`;
    }

    // If not found by ID, return null
    return null;
  };

  const handleRemoveAssignment = (day, hour) => {
    onRemoveAssignment(student._id, day, hour);
  };

  const handleRemoveAll = () => {
    onRemoveAllAssignments(student._id);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="manage-student-dialog" onClick={(e) => e.stopPropagation()}>
        <h3>Manage Assignments</h3>
        <p className="student-name">
          <strong>{student.firstName} {student.lastName}</strong>
        </p>

        {student.assignments && student.assignments.length > 0 ? (
          <>
            <div className="assignments-list">
              <h4>Current Assignments ({student.assignments.length}):</h4>
              {student.assignments.map((assignment, idx) => (
                <div key={idx} className="assignment-item">
                  <span className="assignment-details">
                    📅 {assignment.day} {assignment.hour}:00
                    {assignment.coach && (
                      <> - 👨‍🏫 {getCoachName(assignment.coach) || 'Unbekannt'}</>
                    )}
                  </span>
                  <button
                    className="btn-remove-single"
                    onClick={() => handleRemoveAssignment(assignment.day, assignment.hour)}
                  >
                    Remove
                  </button>
                </div>
              ))}
            </div>

            <div className="dialog-buttons">
              {student.assignments.length > 1 && (
                <button className="btn-remove-all" onClick={handleRemoveAll}>
                  Remove from ALL courses
                </button>
              )}
              <button className="btn-cancel" onClick={onClose}>
                Cancel
              </button>
            </div>
          </>
        ) : (
          <div className="no-assignments">
            <p>No assignments found.</p>
            <button className="btn-cancel" onClick={onClose}>
              Close
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ManageStudentDialog;
